export const LOAD_TECNICOS_AVALIADORES = 'LOAD_TECNICOS_AVALIADORES';
export const TECNICOS_AVALIADORES_DATA = 'TECNICOS_AVALIADORES_DATA';
export const SHOW_TECNICO_AVALIADOR = 'SHOW_TECNICO_AVALIADOR';
export const GET_TECNICO_AVALIADOR = 'GET_TECNICO_AVALIADOR';
export const STORE_TECNICO_AVALIADOR = 'STORE_TECNICO_AVALIADOR';
export const UPDATE_TECNICO_AVALIADOR = 'UPDATE_TECNICO_AVALIADOR';
export const CHANGE_STATUS_CODE = 'CHANGE_STATUS_CODE';
export const TECNICO_AVALIADOR_ERROR = 'TECNICO_AVALIADOR_ERROR';
